import { memo } from 'react';

interface IViewHolderProps {
  cardWidthClass: string;
  setCardWidth: (e: React.MouseEvent<HTMLAnchorElement>, width: string) => void;
}

export const ViewHolder: React.FC<IViewHolderProps> = memo(({ cardWidthClass, setCardWidth }) => {
  return (
    <div className="category-view-holder">
      <strong className="category-view-title">Views:</strong>

      <ul className="category-view-list">
        <li className="full-width-view">
          <a
            href="/"
            className={cardWidthClass === 'full-width' ? 'active' : ''}
            onClick={(e) => setCardWidth(e, 'full-width')}
          >
            <img src={'/assets/images/icon-15.png'} alt="descr" />
          </a>
        </li>

        <li className="third-width-view">
          <a
            href="/"
            className={cardWidthClass === 'third-width' ? 'active' : ''}
            onClick={(e) => setCardWidth(e, 'third-width')}
          >
            <img src={'/assets/images/icon-16.png'} alt="descr" />
          </a>
        </li>

        <li className="fourth-width-view">
          <a
            href="/"
            className={cardWidthClass === 'fourth-width' ? 'active' : ''}
            onClick={(e) => setCardWidth(e, 'fourth-width')}
          >
            <img src={'/assets/images/icon-17.png'} alt="descr" />
          </a>
        </li>

        <li className="two-width-view">
          <a
            href="/"
            className={cardWidthClass === 'two-width' ? 'active' : ''}
            onClick={(e) => setCardWidth(e, 'two-width')}
          >
            <img src={'/assets/images/two-item.png'} alt="descr" />
          </a>
        </li>
      </ul>
    </div>
  );
});
